export const getDefaultSubscriptionLimits = () => ({
    Free: { monthly_basic_limit: 0, monthly_advanced_limit: 0, daily_basic_limit: 0, daily_advanced_limit: 0 },
    Plus: { monthly_basic_limit: 0, monthly_advanced_limit: 0, daily_basic_limit: 0, daily_advanced_limit: 0 },
    Pro: { monthly_basic_limit: 0, monthly_advanced_limit: 0, daily_basic_limit: 0, daily_advanced_limit: 0 },
    Premium: { monthly_basic_limit: 0, monthly_advanced_limit: 0, daily_basic_limit: 0, daily_advanced_limit: 0 },
  });
  
  export const getDefaultSubscriptionPrice = () => ({
    Free: { monthly: 0, yearly: 0 },
    Plus: { monthly: 0, yearly: 0 },
    Pro: { monthly: 0, yearly: 0 },
    Premium: { monthly: 0, yearly: 0 },
  });